// extracted by mini-css-extract-plugin
export default {"onOffButton":"AccionaOnOffButton_onOffButton__RKgTC","onState":"AccionaOnOffButton_onState__6QnrB"};